@if (activeLocale == 'en-CA') {
<p i18n style="font-size:medium; 
font-weight: bold; 
text-decoration: underline;
color: #003F61;
padding-right: 12px;
padding-top: 15px;
margin-right: 21px;
margin-bottom: 0px;
cursor: pointer;" (click)="changeLocale('fr-CA')">Français</p>
}
@if (activeLocale == 'fr-CA') {
<p i18n style="font-size:medium; 
font-weight: bold;
text-decoration: underline; 
color: #003F61;
padding-right: 12px;
padding-top: 15px;
margin-right: 21px;
margin-bottom: 0px;
cursor: pointer;" (click)="changeLocale('en-CA')">English</p>
}